'use strict';

export function showPopEdit({
    recordID = '',
    recordType = '',
    recordForm = '',
    popupTitle = '',
} = {}) {

    var popURL = '/pages/pop/?' + jQuery.param({
        module: 'setting',
        page: recordType + 'Details',
        recordID: recordID,
    });

    popWin({
        title: popupTitle,
        noAutoWidth: true,
        popID: 'recordEdit',
        width: 350,
        modal: true,
        page: popURL,
        dataType: 'json',
        buttons: {
            'Save': function() {
                saveForm(recordForm,false, (data) =>
                {
                    var data = jQuery.parseJSON(data);
                    if (data.success == 'true'){
                        popWinClose('recordEdit');
                        switch (recordType) {
                            case 'keeper':
                                $('#jqGridKeeper').trigger('reloadGrid');
                                break;
                            case 'practitioner':
                                $('#jqGridPractitioner').trigger('reloadGrid');
                                break;
                            case 'farmCategory':
                                $('#jqGridFarmCategory').trigger('reloadGrid');
                                break;
                        }

                    } else {
                        alert(data.message);
                    }
                });
            },
            'Close': function() {
                $(this).dialog('close');
            },
        },
    });

}


export function showDeletePopup(options){
    if (!options) {
        options = {};
    }

    if (!options.recordID) {
        options.recordID = 0;
        alert('Unable to continue as Record ID not specified. Please try again.');
        return;
    }

    if (!options.recordType) {
        options.recordType = '';
        alert('Unable to continue as Record Type not specified. Please try again.');
        return;
    }

    if (!options.recordName) {
        options.recordName = '';
        alert('Unable to continue as Record Name not specified. Please try again.');
        return;
    }

    //Delete Item
    var popURL = '/pages/pop/?' + jQuery.param({
        module: 'setting',
        page: 'settingDelete',
        recordID: options.recordID,
        recordType: options.recordType,
        recordName: options.recordName,
    });

    popWin({
        title: 'Delete ' + options.recordType + ' record?',
        noAutoWidth: true,
        popID: 'deleteSettingPopUp',
        width: 550,
        modal: true,
        page: popURL,
        buttons: {
            'Delete': function () {

                var deleteURL = '/components/general.cfc?' + jQuery.param({
                    'method': 'deleteItem',
                    'dbTable': options.recordType,
                    'dbIDs': options.recordID,
                    'randomVar': gen_random(),
                    'csrfkey': $('#csrfkey').val(),
                });

                $.ajax({
                    type: 'POST',
                    url: deleteURL,
                    data: gen_random(),
                    dataType: 'JSON',
                    cache: false,
                    success: function(data) {
                        if (data.success == 'true'){
                            popWinClose('deleteSettingPopUp');
                            switch (options.recordType) {
                                case 'keeper':
                                    $('#jqGridKeeper').trigger('reloadGrid');
                                    break;
                                case 'practitioner':
                                    $('#jqGridPractitioner').trigger('reloadGrid');
                                    break;
                                case 'farmCategory':
                                    $('#jqGridFarmCategory').trigger('reloadGrid');
                                    break;
                            }
                        } else {
                            EQLAPP.STRIPE.showAlert({
                                title: 'Alert',
                                body: data.message,
                            });
                        }
                    },
                    error: function() {
                        const errorMsg = 'An issue occured while attempting to';
                        errorMsg += ' delete the record. Please try again';
                        EQLAPP.STRIPE.showAlert({
                            title: 'Alert',
                            body: errorMsg,
                        });
                    },
                });

            },
            'Cancel': function () {
                $(this).dialog('close');
            },
        },
    });
}

